import { theme } from '@factorialco/deprecated-design-system'
import apple_calendar from 'assets/images/appStore/apple_calendar/1.jpg'
import ats_1 from 'assets/images/appStore/ats/1.png'
import ats_2 from 'assets/images/appStore/ats/2.png'
import ats_3 from 'assets/images/appStore/ats/3.png'
import ats_4 from 'assets/images/appStore/ats/4.png'
import ats_careers_page_1 from 'assets/images/appStore/ats_careers_page/1.jpg'
import ats_careers_page_2 from 'assets/images/appStore/ats_careers_page/2.jpg'
import ats_careers_page_3 from 'assets/images/appStore/ats_careers_page/3.jpg'
import ats_careers_page_4 from 'assets/images/appStore/ats_careers_page/4.jpg'
import ats_idealdisc from 'assets/images/appStore/ats_idealdisc/1.png'
import ats_whatsapp_1 from 'assets/images/appStore/ats_whatsapp/1.png'
import ats_whatsapp_2 from 'assets/images/appStore/ats_whatsapp/2.png'
import breezy_1 from 'assets/images/appStore/breezy/1.jpg'
import breezy_2 from 'assets/images/appStore/breezy/2.jpg'
import cobee_1 from 'assets/images/appStore/cobee/1.jpg'
import competencies_1 from 'assets/images/appStore/competencies/1.png'
import competencies_2 from 'assets/images/appStore/competencies/2.png'
import competencies_v2_1 from 'assets/images/appStore/competencies_v2/1.png'
import competencies_v2_2 from 'assets/images/appStore/competencies_v2/2.png'
import competencies_v2_3 from 'assets/images/appStore/competencies_v2/3.png'
import competencies_v2_4 from 'assets/images/appStore/competencies_v2/4.png'
// FIXME: This is temporary while we migrate to vite. We want to import all the
// images, and we need a static import. requires do not work the same way in vite
// and webpack , so we need to use imports for all of them. Migrate to `new URL()`
// format when webpack is 🔥. More info:
// https://vitejs.dev/guide/assets.html#new-url-url-import-meta-url
import complaints_1 from 'assets/images/appStore/complaints/1.png'
import complaints_2 from 'assets/images/appStore/complaints/2.png'
import complaints_3 from 'assets/images/appStore/complaints/3.png'
import desky_1 from 'assets/images/appStore/desky/1.jpg'
import desky_2 from 'assets/images/appStore/desky/2.jpg'
import document_templates_1 from 'assets/images/appStore/document_templates/1.png'
import document_templates_2 from 'assets/images/appStore/document_templates/2.png'
import document_templates_3 from 'assets/images/appStore/document_templates/3.png'
import document_templates_4 from 'assets/images/appStore/document_templates/4.png'
import employee_chat_whatsapp_1 from 'assets/images/appStore/employee_chat_whatsapp/1.png'
import employee_chat_whatsapp_2 from 'assets/images/appStore/employee_chat_whatsapp/2.png'
import employee_onboarding_1 from 'assets/images/appStore/employee_onboarding/1.jpg'
import employee_onboarding_2 from 'assets/images/appStore/employee_onboarding/2.png'
import employee_onboarding_3 from 'assets/images/appStore/employee_onboarding/3.png'
import enps_1 from 'assets/images/appStore/enps/1.png'
import enps_2 from 'assets/images/appStore/enps/2.png'
import enps_3 from 'assets/images/appStore/enps/3.png'
import expenses_1 from 'assets/images/appStore/expenses/1.jpg'
import expenses_2 from 'assets/images/appStore/expenses/2.jpg'
import expenses_3 from 'assets/images/appStore/expenses/3.jpg'
import expenses_v2_1 from 'assets/images/appStore/expenses_v2/1.gif'
import expenses_v2_1_thumb from 'assets/images/appStore/expenses_v2/1.png'
import expenses_v2_2 from 'assets/images/appStore/expenses_v2/2.gif'
import expenses_v2_2_thumb from 'assets/images/appStore/expenses_v2/2.png'
import expenses_v2_3 from 'assets/images/appStore/expenses_v2/3.gif'
import expenses_v2_3_thumb from 'assets/images/appStore/expenses_v2/3.png'
import expenses_v2_4 from 'assets/images/appStore/expenses_v2/4.gif'
import expenses_v2_4_thumb from 'assets/images/appStore/expenses_v2/4.png'
import finance_1 from 'assets/images/appStore/finance/1.png'
import finance_2 from 'assets/images/appStore/finance/2.png'
import finance_3 from 'assets/images/appStore/finance/3.png'
import finance_4 from 'assets/images/appStore/finance/4.png'
import gmail_1 from 'assets/images/appStore/gmail/1.jpg'
import google_calendar_1 from 'assets/images/appStore/google_calendar/1.jpg'
import growth_plans_1 from 'assets/images/appStore/growth_plans/1.jpg'
import growth_plans_2 from 'assets/images/appStore/growth_plans/2.jpg'
import indeed_1 from 'assets/images/appStore/indeed/1.jpg'
import indeed_2 from 'assets/images/appStore/indeed/2.jpg'
import join_1 from 'assets/images/appStore/join/1.jpg'
import join_2 from 'assets/images/appStore/join/2.jpg'
import join_3 from 'assets/images/appStore/join/3.jpg'
import linkedin_1 from 'assets/images/appStore/linkedin/1.jpg'
import linkedin_2 from 'assets/images/appStore/linkedin/2.jpg'
import linkedin_limited_listings_1 from 'assets/images/appStore/linkedin_limited_listings/1.png'
import outlook_1 from 'assets/images/appStore/outlook/1.jpg'
import outlook_calendar from 'assets/images/appStore/outlook_calendar/1.jpg'
import payflow_1 from 'assets/images/appStore/payflow/1.jpg'
import payroll_bundle_1 from 'assets/images/appStore/payroll_bundle/1.png'
import payroll_bundle_2 from 'assets/images/appStore/payroll_bundle/2.png'
import payroll_bundle_3 from 'assets/images/appStore/payroll_bundle/3.png'
import payroll_bundle_4 from 'assets/images/appStore/payroll_bundle/4.png'
import recruitee_1 from 'assets/images/appStore/recruitee/1.jpg'
import recruitee_2 from 'assets/images/appStore/recruitee/2.jpg'
import shift_management_1 from 'assets/images/appStore/shift_management/1.jpg'
import shift_management_2 from 'assets/images/appStore/shift_management/2.jpg'
import shift_management_3 from 'assets/images/appStore/shift_management/3.jpg'
import shift_management_4 from 'assets/images/appStore/shift_management/4.jpg'
import slack_1 from 'assets/images/appStore/slack/1.jpg'
import surveys_1 from 'assets/images/appStore/surveys/1.png'
import surveys_2 from 'assets/images/appStore/surveys/2.png'
import surveys_3 from 'assets/images/appStore/surveys/3.png'
import surveys_4 from 'assets/images/appStore/surveys/4.png'
import tasks_management_1 from 'assets/images/appStore/tasks_management/1.jpg'
import tasks_management_2 from 'assets/images/appStore/tasks_management/2.jpg'
import tasks_management_3 from 'assets/images/appStore/tasks_management/3.jpg'
import time_tracking_1 from 'assets/images/appStore/time_tracking/1.jpg'
import time_tracking_2 from 'assets/images/appStore/time_tracking/2.jpg'
import time_tracking_3 from 'assets/images/appStore/time_tracking/3.jpg'
import time_tracking_4 from 'assets/images/appStore/time_tracking/4.jpg'
import trainings_1 from 'assets/images/appStore/trainings/1.png'
import trainings_2 from 'assets/images/appStore/trainings/2.png'
import zapier_1 from 'assets/images/appStore/zapier/1.jpg'

import hasFeature from 'modules/core/lib/hasFeature'
import { HelpCenterNewRequest, HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'
import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

export interface ConfigType {
  id: string
  dependeeId?: string
  customUninstallCopy?: boolean
  color?: string
  backgroundColor?: string
  onSuccessActivate?: () => void
  onSuccessActivateEnps?: (id: number) => () => void
  images: string[]
  thumbs?: string[]
  helpLink?: {
    default?: HelpCenterUrl | HelpCenterNewRequest
  }
  contactLink?: string
  supportLink?: string
  hasSettings?: boolean
  enabled?: boolean
  endpoint?: string
}

const refreshAndGoto = (path: string) => () => {
  window.location.href = path
}

interface Colors {
  [key: string]: string
}

const colorAndBgColor = (key: string) => ({
  color: (theme.colors as Colors)[`${key}1000`],
  backgroundColor: (theme.colors as Colors)[`${key}200`],
})

const getAddonsConfig = (navigation: Navigation<NavigationPaths>): ConfigType[] => [
  {
    id: 'complaints',
    onSuccessActivate: refreshAndGoto(navigation.settings.complaints.fullPath()),
    images: [complaints_1, complaints_2, complaints_3],
    hasSettings: hasFeature('complaints'),
    customUninstallCopy: true,
    ...colorAndBgColor('champagne'),
  },
  {
    id: 'competencies',
    onSuccessActivate: refreshAndGoto(navigation.competencies.fullPath()),
    images: [competencies_v2_1, competencies_v2_2, competencies_v2_3, competencies_v2_4],
    hasSettings: hasFeature('competencies'),
    ...colorAndBgColor('champagne'),
  },
  {
    id: 'employee_onboarding',
    dependeeId: 'tasks_management',
    onSuccessActivate: refreshAndGoto(navigation.settings.employee_onboarding.fullPath()),
    images: [employee_onboarding_1, employee_onboarding_2, employee_onboarding_3],
    hasSettings: hasFeature('employee_onboarding'),
    ...colorAndBgColor('radical'),
  },
  {
    id: 'enps',
    onSuccessActivateEnps: () =>
      refreshAndGoto(navigation.engagement.enps.configuration.fullPath()),
    images: [enps_1, enps_2, enps_3],
    ...colorAndBgColor('champagne'),
  },
  {
    id: 'trainings_custom_table',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [trainings_1, trainings_2],
    hasSettings: hasFeature('trainings_custom_table'),
    ...colorAndBgColor('malibu'),
  },
  {
    id: 'growth_plans_custom_table',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [growth_plans_1, growth_plans_2],
    hasSettings: hasFeature('growth_plans_custom_table'),
    ...colorAndBgColor('radical'),
  },
  {
    id: 'competencies_custom_table',
    onSuccessActivate: refreshAndGoto(navigation.competencies.fullPath()),
    images: [competencies_1, competencies_2],
    hasSettings: hasFeature('competencies_custom_table'),
    ...colorAndBgColor('champagne'),
  },
  {
    id: 'goals',
    images: [],
    enabled: false,
    ...colorAndBgColor('champagne'),
  },
  {
    id: 'surveys',
    onSuccessActivate: refreshAndGoto(navigation.engagement.fullPath()),
    images: [surveys_1, surveys_2, surveys_3, surveys_4],
    hasSettings: true,
    ...colorAndBgColor('lime'),
  },
  {
    id: 'performance_v2',
    images: [],
    enabled: false,
    ...colorAndBgColor('lime'),
  },
  {
    id: 'ats',
    dependeeId: 'ats_careers_page',
    onSuccessActivate: refreshAndGoto(navigation.ats.fullPath()),
    helpLink: {
      default: 'recruitment',
    },
    images: [ats_1, ats_2, ats_3, ats_4],
    hasSettings: true,
    ...colorAndBgColor('viridian'),
  },
  {
    id: 'join',
    helpLink: {
      default: 'new_request',
    },
    images: [join_1, join_2, join_3],
    hasSettings: false,
    backgroundColor: '#fff',
  },
  {
    id: 'cobee',
    helpLink: {
      default: 'new_request',
    },
    supportLink: 'https://cobee.io/factorial/',
    images: [cobee_1],
    hasSettings: false,
    backgroundColor: '#2DEFA9',
  },
  {
    id: 'desky',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [desky_1, desky_2],
    color: '#fff',
    backgroundColor: '#fff',
  },
  {
    id: 'ats_careers_page',
    onSuccessActivate: refreshAndGoto(navigation.careers.fullPath()),
    helpLink: {
      default: 'careers_page',
    },
    images: [ats_careers_page_1, ats_careers_page_2, ats_careers_page_3, ats_careers_page_4],
    ...colorAndBgColor('champagne'),
  },
  {
    id: 'payroll_bundle',
    onSuccessActivate: refreshAndGoto(navigation.settings.payroll_bundle.fullPath()),
    helpLink: {
      default: 'payroll_bundle',
    },
    images: [payroll_bundle_1, payroll_bundle_2, payroll_bundle_3, payroll_bundle_4],
    hasSettings: true,
    ...colorAndBgColor('malibu'),
  },
  {
    id: 'tasks_management',
    onSuccessActivate: refreshAndGoto(navigation.tasks.fullPath()),
    helpLink: {
      default: 'tasks',
    },
    images: [tasks_management_1, tasks_management_2, tasks_management_3],
    ...colorAndBgColor('malibu'),
  },
  {
    id: 'shift_management',
    onSuccessActivate: refreshAndGoto(navigation.shifts.fullPath()),
    helpLink: {
      default: 'shifts',
    },
    images: [shift_management_1, shift_management_2, shift_management_3, shift_management_4],
    ...colorAndBgColor('radical'),
  },
  {
    id: 'time_tracking',
    onSuccessActivate: refreshAndGoto(navigation.settings.time_tracking.fullPath()),
    helpLink: {
      default: 'time_tracking',
    },
    images: [time_tracking_1, time_tracking_2, time_tracking_3, time_tracking_4],
    hasSettings: true,
    ...colorAndBgColor('radical'),
  },
  {
    id: 'expenses',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    helpLink: {
      default: 'expenses',
    },
    images: [expenses_1, expenses_2, expenses_3],
    hasSettings: true,
    ...colorAndBgColor('viridian'),
  },
  {
    id: 'expenses_v2',
    helpLink: {
      default: 'expenses_v2',
    },
    onSuccessActivate: refreshAndGoto(navigation.expenses.fullPath()),
    images: [expenses_v2_1, expenses_v2_2, expenses_v2_3, expenses_v2_4],
    thumbs: [expenses_v2_1_thumb, expenses_v2_2_thumb, expenses_v2_3_thumb, expenses_v2_4_thumb],
    hasSettings: true,
    ...colorAndBgColor('viridian'),
  },
  {
    id: 'finance',
    onSuccessActivate: refreshAndGoto(navigation.finance.fullPath()),
    images: [finance_1, finance_2, finance_3, finance_4],
    hasSettings: true,
    ...colorAndBgColor('malibu'),
  },
  {
    id: 'document_templates',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    helpLink: {
      default: 'document_templates',
    },
    images: [
      document_templates_1,
      document_templates_2,
      document_templates_3,
      document_templates_4,
    ],
    hasSettings: false,
    enabled: hasFeature('document_templates'),
    ...colorAndBgColor('viridian'),
  },
  {
    id: 'space_control',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    helpLink: {
      default: 'space_control',
    },
    enabled: hasFeature('dev_space_control'),
    hasSettings: false,
    images: [desky_1, desky_2],
    ...colorAndBgColor('lime'),
  },
  {
    id: 'google_calendar',
    helpLink: {
      default: 'new_request',
    },
    images: [google_calendar_1],
    color: '#1E88E5',
    backgroundColor: '#fff',
  },
  {
    id: 'apple_calendar',
    helpLink: {
      default: 'new_request',
    },
    images: [apple_calendar],
    color: '#1E88E5',
    backgroundColor: '#fff',
  },
  {
    id: 'outlook_calendar',
    helpLink: {
      default: 'new_request',
    },
    images: [outlook_calendar],
    color: '#1E88E5',
    backgroundColor: '#fff',
  },
  {
    id: 'zapier',
    images: [zapier_1],
    helpLink: {
      default: 'new_request',
    },
    color: '#FF4A00',
    backgroundColor: '#fff',
  },
  {
    id: 'slack',
    images: [slack_1],
    helpLink: {
      default: 'new_request',
    },
    color: '#000',
    backgroundColor: '#fff',
  },
  {
    id: 'gmail',
    images: [gmail_1],
    helpLink: {
      default: 'new_request',
    },
    color: '#D54B3D',
    backgroundColor: '#fff',
  },
  {
    id: 'outlook',
    images: [outlook_1],
    helpLink: {
      default: 'new_request',
    },
    color: '#0072C6',
    backgroundColor: '#fff',
  },
  {
    id: 'breezy',
    images: [breezy_1, breezy_2],
    helpLink: {
      default: 'new_request',
    },
    color: '#fff',
    backgroundColor: '#25A4D3',
  },
  {
    id: 'recruitee',
    images: [recruitee_1, recruitee_2],
    helpLink: {
      default: 'new_request',
    },
    color: '#fff',
    backgroundColor: '#198FD4',
  },
  {
    id: 'indeed',
    images: [indeed_1, indeed_2],
    helpLink: {
      default: 'new_request',
    },
    color: '#fff',
    backgroundColor: '#2063F2',
  },
  {
    id: 'linkedin',
    images: [linkedin_1, linkedin_2],
    helpLink: {
      default: 'new_request',
    },
    color: '#fff',
    backgroundColor: '#2D74AE',
  },
  {
    id: 'linkedin_limited_listings',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [linkedin_limited_listings_1],
    color: '#fff',
    backgroundColor: '#fff',
    hasSettings: hasFeature('linkedin_limited_listings'),
  },
  {
    id: 'payflow',
    images: [payflow_1],
    contactLink: 'soporte_empresas@payflow.es',
    color: '#fff',
    backgroundColor: '#fff',
  },
  {
    id: 'ats_whatsapp',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [ats_whatsapp_1, ats_whatsapp_2],
    color: '#fff',
    backgroundColor: '#fff',
  },
  {
    id: 'employee_chat_on_whatsapp',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [employee_chat_whatsapp_1, employee_chat_whatsapp_2],
    color: '#fff',
    backgroundColor: '#fff',
  },
  {
    id: 'ats_ideal_disc_integration',
    onSuccessActivate: refreshAndGoto(navigation.discover.marketplace.fullPath()),
    images: [ats_idealdisc],
    color: '#fff',
    backgroundColor: '#fff',
  },
]

class SubscriptionAddonConfigurator {
  configurations: ConfigType[] | null | undefined

  getSubscriptionAddonConfig(
    subscriptionAddon: SubscriptionAddon | undefined,
    navigation: Navigation<NavigationPaths>
  ): ConfigType {
    this.configurations = this.configurations || getAddonsConfig(navigation)

    const config = this.configurations.find(
      (config) => config.id === subscriptionAddon?.attributes.id
    )

    if (!config) {
      throw new Error(`Unable to retrieve the addon config ${subscriptionAddon?.attributes.id}`)
    }

    return config
  }

  helpLink(
    subscriptionAddon: SubscriptionAddon,
    navigation: Navigation<NavigationPaths>
  ): HelpCenterUrl | HelpCenterNewRequest | undefined {
    const { helpLink } = this.getSubscriptionAddonConfig(subscriptionAddon, navigation)

    return helpLink?.default
  }

  contactLink(
    subscriptionAddon: SubscriptionAddon,
    navigation: Navigation<NavigationPaths>
  ): string | null | undefined {
    const { contactLink } = this.getSubscriptionAddonConfig(subscriptionAddon, navigation)
    return contactLink
  }
  supportLink(
    subscriptionAddon: SubscriptionAddon,
    navigation: Navigation<NavigationPaths>
  ): string | null | undefined {
    const { supportLink } = this.getSubscriptionAddonConfig(subscriptionAddon, navigation)

    return supportLink
  }
}
const singleton: SubscriptionAddonConfigurator = new SubscriptionAddonConfigurator()

export default singleton
